<template>
  <scout-form
    label="経験業種・希望業種"
    has-child
  >
    <div class="boss-table-2-layout">
      <div
        class="boss-table-2-item boss-table-2-item-body"
        :class="{ 'is-modified': desiredBusinesses.length || experiencedBusinesses.length }"
      >
        <div class="boss-separated-small">
          <div class="boss-layout boss-layout-start boss-layout-gap-large">
            <label
              v-for="(option, i) in options"
              :key="i"
              :data-test="`label-${i}`"
              class="pega-input"
            >
              <input
                :checked="selectedOption === option.key"
                :value="option.key"
                :data-test="`radio-${i}`"
                class="boss-input-checkbox"
                type="radio"
                @change="$emit('update:selectedOption', $event.target.value)"
              >{{ option.label }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div
      class="boss-table-2-layout"
      data-test="experienced-occupation"
    >
      <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact">
        経験業種
      </div>
      <div
        class="boss-table-2-item boss-table-2-item-body"
        :class="{ 'is-modified': experiencedBusinesses.length }"
        data-test="experienced-occupation-body"
      >
        <select-modal-button
          v-if="businessesMaster.length > 0"
          :master-data="businessesMaster"
          :selected-items="experiencedBusinesses.map(n => { return { id: n, experience: '' } })"
          title="業種"
          suffix="experienced-businesses"
          data-test="experienced-businesses-modal"
          @update-modal-checked-ids="value => $emit('update:experiencedBusinesses', value.map(o => o.id))"
        />
      </div>
    </div>
    <div
      class="boss-table-2-layout"
      data-test="desired-occupation"
    >
      <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact">
        希望業種
      </div>
      <div
        class="boss-table-2-item boss-table-2-item-body"
        :class="{ 'is-modified': desiredBusinesses.length}"
        data-test="desired-occupation-body"
      >
        <label class="boss-checkbox">
          <input
            :checked="containBusinessesNonHopeUser"
            class="boss-input-checkbox"
            type="checkbox"
            data-test="check-box"
            @change="$emit('update:containBusinessesNonHopeUser', $event.target.checked)"
          >希望業種を「こだわらない・未入力」としている会員を含む
        </label>
        <select-modal-button
          v-if="businessesMaster.length > 0"
          :master-data="businessesMaster"
          :selected-items="desiredBusinesses.map(n => { return { id: n, experience: '' } })"
          title="業種"
          suffix="desired-businesses"
          data-test="desired-businesses-modal"
          @update-modal-checked-ids="value => $emit('update:desiredBusinesses', value.map(o => o.id))"
        />
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import SelectModalButton from '@/components/organisms/SelectModalButton'
import * as definition from '@/lib/labelValueMappings'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutForm,
    SelectModalButton
  },
  props: {
    selectedOption: {
      default: '',
      type: String
    },
    experiencedBusinesses: {
      required: true,
      type: Array
    },
    desiredBusinesses: {
      required: true,
      type: Array
    },
    containBusinessesNonHopeUser: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      options: definition.businessOperators
    }
  },
  computed: {
    ...mapGetters([
      'businessesMaster'
    ])
  }
}
</script>
